<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="back">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <h2 class="page-title">ポイント付与</h2>
        <form v-on:submit.prevent="create">
          <div class="form-group">
            <label class="form-label">付与ポイント数</label>
            <input v-model="point_num" type="text" class="form-control" pattern="\d+" required placeholder="10"/>
          </div>
          <div class="btn-row">
            <button type="submit" class="btn-primary">付与</button>
            <button type="button" v-on:click="back" class="btn-secondary">戻る</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import store from "@/store";

export default {
  data: function () {
    return {
      point_num: "",
    }
  },
  async mounted() {
  },
  methods: {
    create: function () {
      const data = {
        point_num: this.point_num,
      }
      axios.post("/update_point", data).then((res) => {
        router.push("/menu")
      });
    },
    back: function () {
      router.push("/menu")
    },
    logout: function () {
      store.dispatch("logout")
    },
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 960px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.10);
  padding: 32px 40px;
}

.page-title {
  font-size: 1.3rem; font-weight: 700;
  color: #1E293B; margin: 0 0 24px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #E2E8F0;
}

.form-group { margin-bottom: 20px; }

.form-label {
  display: block; font-size: 0.85rem; font-weight: 600;
  color: #475569; margin-bottom: 6px;
}

.form-control {
  width: 100%; padding: 10px 14px; border-radius: 8px;
  border: 1.5px solid #CBD5E1; font-size: 0.9rem;
  font-family: inherit; outline: none; box-sizing: border-box;
  transition: border-color 0.2s;
}
.form-control:focus { border-color: #3B82F6; }

.btn-row {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-primary {
  padding: 10px 24px; border-radius: 8px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s;
}
.btn-primary:hover { background: #2563EB; }

.btn-secondary {
  padding: 10px 24px; border-radius: 8px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; }
</style>
